import React, { createContext } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useRouteMatch } from "react-router-dom";

import _ from "lodash";

import { fetchingCustomFormField, fetchCustomFormFields, deleteCustomFormField, createCustomFormField, updateCustomFormField, invalidateCustomFormFields } from 'actions/formFields';
import { FieldsView } from 'components/Fields';

import { getBaseUrl } from 'services/util';
import styles from './../../../components/Fields/fields.module.scss';
import { getPageViewedEventPayload } from 'services/mixpanelUtil';
import { MIXPANEL_PAGE_VIEWED, MIXPANEL_PAGE_VIEWED_CUSTOM_FORM_FIELDS } from 'constants/mixpanelEvents';
import { createMixpanelEvent } from 'actions/mixpanel';
import { useEffect } from 'react';

export const FormFieldsContext = createContext();

export default function CustomFormFieldsView() {
  const dispatch = useDispatch();

  let { url } = useRouteMatch();
  let baseUrl = getBaseUrl(url);

  const loading = useSelector((state) => _.get(state, "formFields.loading") || false);
  const creating = useSelector((state) => _.get(state, "formFields.creating") || false);
  const updating = useSelector((state) => _.get(state, "formFields.updating") || false);

  const workspaceId = useSelector((state) => _.get(state, "workspaces.workspace.item.id") || null);
  const storyboardId = useSelector((state) => _.get(state, "storyboards.storyboard.item.id") || null);
  const storyboardName = useSelector((state) => _.get(state, "storyboards.storyboard.item.name") || null);
  const storyboardType = useSelector((state) => _.get(state, "storyboards.storyboard.item.type") || null);

  const customFields = useSelector((state) => _.get(state, "formFields.items") || []);
  const currentField = useSelector((state) => _.get(state, "formFields.currentField") || null);

  const FormFieldsContextValue = {
    path: `${baseUrl}/integration-settings/form-fields/`,
    fetchCustomFields: fetchCustomFormFields,
    fetchingCustomField: fetchingCustomFormField,
    createCustomField: createCustomFormField,
    updateCustomField: updateCustomFormField,
    deleteCustomField: deleteCustomFormField,
    invalidateCustomFields: invalidateCustomFormFields,
    entityType: "FORM"
  }

  useEffect(() => {
    var mixPanelPayload = getPageViewedEventPayload(MIXPANEL_PAGE_VIEWED_CUSTOM_FORM_FIELDS)
    dispatch(createMixpanelEvent(MIXPANEL_PAGE_VIEWED, mixPanelPayload))    
  }, [])

  return (
    <div className={styles.fieldsSection}>
      <div className={styles.header}>Custom Form Fields</div>
      <div className={styles.description}>One space to manage them all</div>
      
        <FormFieldsContext.Provider value={FormFieldsContextValue}>
          <FieldsView 
            loading={loading}
            creating={creating}
            updating={updating} 
            storyboardId={storyboardId} 
            workspaceId={workspaceId} 
            customFields={customFields} 
            currentField={currentField} 
            entityType={"FORM"}
          />
        </FormFieldsContext.Provider>
    </div>
  )
}